import { useEffect, useRef } from 'react';
import { registerParallax, motionLevel } from '../../lib/living';

/* 3D depth card. Follows the mouse (desktop) and the phone's gyroscope
 * (via the parallax bus), with a moving light glare. Children can pop out
 * of the surface with the `.depth-1/2/3` helper classes.
 */
export default function Tilt({ as: Tag = 'div', className = '', max = 9, glare = true, children, ...rest }) {
    const ref = useRef(null);

    useEffect(() => registerParallax(ref.current), []);

    const onMove = (e) => {
        if (e.pointerType !== 'mouse' || motionLevel() !== 'full') return;
        const el = ref.current;
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--rx', `${((0.5 - y) * max).toFixed(2)}deg`);
        el.style.setProperty('--ry', `${((x - 0.5) * max).toFixed(2)}deg`);
        el.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
        el.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
        el.classList.add('is-tilting');
    };

    const onLeave = () => {
        const el = ref.current;
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
        el.classList.remove('is-tilting');
    };

    return (
        <Tag ref={ref} className={`tilt ${className}`} onPointerMove={onMove} onPointerLeave={onLeave} {...rest}>
            {children}
            {glare && <span className="tilt-holo" aria-hidden><span className="holo-foil" /></span>}
            {glare && <span className="tilt-glare" aria-hidden />}
        </Tag>
    );
}
